import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfirmationService {
  private confirmation$ = new BehaviorSubject<IConfirmation | null>(null);

  listen() {
    return this.confirmation$.asObservable();
  }

  confirm(payload: Omit<IConfirmation, 'answer'>) {
    const answer = new Subject<any>();
    this.confirmation$.next({ ...payload, answer } as IConfirmation);
    return answer.pipe(take(1));
  }
}

export const provideConfirmationService = () => ({
  provide: ConfirmationService,
  useClass: ConfirmationService,
});

interface IConfirmation {
  confirmation: string[];
  revertable: boolean;
  deniable: boolean;
  answer: Subject<boolean>;
}
